import React, { useContext, useState } from "react";
import { CustomI18nextContext } from "../../contexts/CustomI18nextContext";
import GetOnBoard from "../../components/ContentComponents/GetOnBoard";
import ContactForm from "../../components/Forms/ContactForm";
import Toast, { showToast } from "../../components/Toast";
import { getAcfPartialContent } from "../../utils";
import { getFormName, FORM_TYPES } from "../../hooks/useContactForm";
import { submitContactForm } from "../../client";

const ContactUsLayout = ({ data }) => {
  const { t, siteCountry } = useContext(CustomI18nextContext);

  const [recaptchaResponse, setRecaptchaResponse] = useState("");

  const submitForm = async (formName, values, resetForm) => {
    try {
      await submitContactForm({
        "form-name": formName,
        ...values,
        "g-recaptcha-response": recaptchaResponse,
      });

      showToast("contact-us", "success");
      resetForm();
    } catch (err) {
      showToast("contact-us", "error");
    }
  };

  const handleRecaptcha = (value) => {
    setRecaptchaResponse(value);
  };

  return (
    <>
      <div className="pt-5">
        <div className="container my-5">
          <div className="text-center">
            <h1 className="mb-5">{t("contactUs.title")}</h1>
          </div>
          <div className="row">
            <div className="col-lg-6 offset-lg-3 mb-5">
              <ContactForm
                formName={getFormName(FORM_TYPES.SUPPORT, siteCountry)}
                submitForm={submitForm}
                handleRecaptcha={handleRecaptcha}
                recaptchaResponse={recaptchaResponse}
              />
            </div>
            <div className="col-lg-3 text-center">
              {data.currentOfficeLocation.edges.map((post, i) => (
                <div key={`location-icon-${i}`} className="card p-4">
                  <img
                    className="location-icon"
                    src={
                      post.node.acfOfficeLocations.olLocationIcon.localFile
                        .publicURL
                    }
                    alt={post.node.title}
                  />
                  <h2
                    className="mb-4"
                    dangerouslySetInnerHTML={{ __html: post.node.title }}
                  />
                  <div
                    className="location-address"
                    dangerouslySetInnerHTML={{ __html: post.node.content }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* acf: after_contact_form start */}
        {data.afterContactForm ? (
          data.afterContactForm.edges.map((post, i) => (
            <div key={`after-contact-form-${i}`} id={post.node.slug}>
              <div className="container py-5">
                <div dangerouslySetInnerHTML={{ __html: post.node.content }} />
              </div>
            </div>
          ))
        ) : (
          <div className="container py-5" />
        )}
        {/* acf: after_contact_form end */}

        <div className="container my-5">
          <h2 className="my-5 text-center">
            {t("contactUs.ourOffices.title")}
          </h2>
          <div className="row justify-content-center">
            {data.allOfficeLocations.edges.map((post, i) => (
              <div
                key={`office-location-${i}`}
                className="col-lg-3 text-center"
              >
                <img
                  className="location-icon"
                  src={
                    post.node.acfOfficeLocations.olLocationIcon.localFile
                      .publicURL
                  }
                  alt={post.node.title}
                />
                <h2
                  className="mb-4"
                  dangerouslySetInnerHTML={{ __html: post.node.title }}
                />
                <div
                  className="location-address"
                  dangerouslySetInnerHTML={{ __html: post.node.content }}
                />
              </div>
            ))}
          </div>
        </div>
        <GetOnBoard content={getAcfPartialContent(data.getOnBoardContent)} />
      </div>

      <Toast
        containerId="contact-us"
        toastStatus="success"
        header="Thank you!"
        description="Your form submission has been received."
      />
      <Toast
        containerId="contact-us"
        toastStatus="error"
        header="Something went wrong"
        description="Please try again later."
      />
    </>
  );
};

export default ContactUsLayout;
